export function clipboard(value: string, element?: HTMLElement) {
  const parent = element || document.body;
  const textArea = document.createElement("textArea") as HTMLTextAreaElement;
  textArea.value = value;
  parent.appendChild(textArea);
  textArea.select();
  document.execCommand("copy");
  parent.removeChild(textArea);
}

export default clipboard;
